import { render, staticRenderFns } from "./VideoSlide.vue?vue&type=template&id=95ea0b48&scoped=true&"
import script from "./VideoSlide.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoSlide.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoSlide.vue?vue&type=style&index=0&id=95ea0b48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ea0b48",
  null
  
)

export default component.exports